import { render, staticRenderFns } from "./BondRecordAdd2.vue?vue&type=template&id=2fadb75a&scoped=true"
import script from "./BondRecordAdd2.vue?vue&type=script&lang=js"
export * from "./BondRecordAdd2.vue?vue&type=script&lang=js"
import style0 from "./BondRecordAdd2.vue?vue&type=style&index=0&id=2fadb75a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fadb75a",
  null
  
)

export default component.exports